import React from "react";
import { Button, Dialog, DialogTitle, Box, IconButton, CircularProgress } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const CustomModal = ({
  title,
  btnText,
  btnDisabled,
  btnOnClick,
  btnColor = "secondary",
  visible,
  setVisible,
  width = "500px",
  children,
  noBtn = false,
  notCloseable = false,
  loading = false,
  background = "#fff",
}) => {
  return (
    <Dialog
      open={visible}
      onClose={notCloseable ? undefined : () => setVisible(false)}
      PaperProps={{
        sx: {
          borderRadius: "24px",
          overflow: "hidden",
          width: width,
          padding: 2,
          gap: 2,
          background: background,
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: 700,
          fontSize: "1.5rem",
          position: "relative",
          padding: "0px 0px 0px 8px",
          m: 0,
          color: "#439BD9",
        }}
      >
        {title}
{!notCloseable && (
          <IconButton
            aria-label="close"
            onClick={() => setVisible(false)}
            sx={{
              position: "absolute",
              right: 0,
              top: 0,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        )}
      </DialogTitle>
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "200px",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        children
      )}
      {noBtn ? null : (
        <Box
          sx={{
            p: 0.5,
          }}
        >
          <Button
            variant="contained"
            color={btnColor}
            sx={{
              height: "auto",
              float: "right",
              textTransform: "none",
              fontSize: "1rem",
              borderRadius: "50px",
              px: "20px",
              py: "10px",
            }}
            onClick={btnOnClick}
            disabled={btnDisabled}
          >
            {btnText}
          </Button>
        </Box>
      )}
    </Dialog>
  );
};

export default CustomModal;
